import request from '@/services/interceptor.js'

// Client generico per le anagrafiche piatte (articoli, nodi, uf-legno, comuni, province,
// valori-limite): stesse rotte REST e stesso import CSV (vedi AnagraficaControllerBase).
export const anagrafica_lista = (endpoint, params) => {
    return request({ url: `/${endpoint}`, method: 'get', params: params || {}, loadingBar: true })
}

export const anagrafica_crea = (endpoint, dati) => {
    return request({ url: `/${endpoint}`, method: 'post', data: dati, loadingBar: true })
}

export const anagrafica_aggiorna = (endpoint, id, dati) => {
    return request({ url: `/${endpoint}/${id}`, method: 'put', data: dati, loadingBar: true })
}

export const anagrafica_elimina = (endpoint, id) => {
    return request({ url: `/${endpoint}/${id}`, method: 'delete', loadingBar: true })
}

export const anagrafica_importa = (endpoint, file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({ url: `/${endpoint}/import`, method: 'post', data: formData, loadingBar: true })
}
